(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .controller('CronogramaFungicidasCtrl', CronogramaFungicidasCtrl);

  CronogramaFungicidasCtrl.$inject = [
    'LoadingService',
    'MessagesService',
    '$rootScope',
    'CronogramaFungicidasService',
    'AtividadesService',
    '$uibModal'
  ];

  // eslint-disable-next-line max-lines-per-function, max-params
  function CronogramaFungicidasCtrl(LoadingService, MessagesService, $rootScope, CronogramaFungicidasService,
    AtividadesService, $uibModal) {
    const vm = this;

    // Controller data
    vm.loading = true;
    vm.schedules = [];
    vm.safra = null;
    vm.atividades = [];
    vm.atividade = null;
    vm.gleba = null;
    vm.scheduleForDuplication = null;
    vm.duplicationTargets = [];

    // Bindable methods
    vm.createNew = createNew;
    vm.loadSchedules = loadSchedules;
    vm.reportDemandaUso = reportDemandaUso;

    // Function declarations
    function loadAtividades() {
      return AtividadesService.listComEmpreendimento()
        .then(({ data }) => {
          vm.atividades = data;
        });
    }

    function loadSchedules() {
      vm.loading = true;
      vm.schedules = [];

      return CronogramaFungicidasService.loadSchedules({
        safra: vm.safra.id,
        propriedade: $rootScope.currentPropriedade.id,
        atividade: _.get(vm.atividade, 'id'),
        gleba: _.get(vm.gleba, 'id')
      })
        .then((data) => {
          vm.schedules = data;
        })
        .catch((error) => {
          MessagesService.alert('Erro ao carregar cronogramas, tente novamente mais tarde');
          console.error(error);
        })
        .finally(() => {
          vm.loading = false;
        });
    }

    function createNew() {
      const modal = $uibModal.open({
        controller: 'CronogramaFungicidasCreateCtrl',
        controllerAs: '$create',
        templateUrl: 'views/cronograma_fungicidas/create.html',
        resolve: {
          atividades: () => vm.atividades,
          atividade: () => vm.atividade,
          safra: () => vm.safra,
          gleba: () => vm.gleba
        },
        backdrop: 'static'
      });
      modal.result
        .then(() => loadSchedules())
        .catch((error) => {
          console.error(error);
        });
    }

    function reportDemandaUso(event) {
      preventDefault(event);

      $uibModal.open({
        animation: true,
        ariaLabelledBy: 'modal-title',
        ariaDescribedBy: 'modal-body',
        templateUrl: 'modal-report-demanda-uso.html',
        controller: 'DemandaUsoInsumosCtrl',
        controllerAs: 'DemandaUsoInsumos',
        resolve: {
          operacao: function() {
            return {};
          },
          cronograma: function() {
            return true;
          },
          aguardandoAprovacao: function() {
            return false;
          },
          aplicacoes: function() {
            return {};
          }
        }
      });
    }

    // Controller logic
    LoadingService.showLoading();
    $rootScope.initialize
      .then(() => {
        if (!$rootScope.permissions.recomendacao.canRead) {
          MessagesService.alert(ACESSO_NAO_PERMITIDO.msg);
          return;
        }

        $rootScope.bodyClass = 'gray-bg';
        vm.safra = _.find($rootScope.safras, 'current');
        return loadAtividades();
      })
      .then(() => {
        loadSchedules();
      })
      .catch(() => {
        $rootScope.errorRootInitialize();
      })
      .finally(LoadingService.hideLoading);
  }
}());
